import { render, staticRenderFns } from "./ListDetail.vue?vue&type=template&id=3e625b6b&"
import script from "./ListDetail.vue?vue&type=script&lang=js&"
export * from "./ListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports